import axiosClient from "@/utils/axios-client";
import { PathPickOrderDetailResponse } from "@/features/pathpick/features/order-history/types/response";

const url = {
  // 명세상 order_id는 문자열이고, 숫자 id 대신 주문번호(PP-...)도 받는다.
  getPathPickOrderDetail: (companyId: number, orderId: number | string) =>
    `/buyers/${companyId}/pathpick/orders/${orderId}`,
};

export const pathPickOrderDetailQueryApi = {
  // 패스픽 주문 단건 상세 조회 (상품/옵션별 신청·확정·취소 수량 포함)
  getPathPickOrderDetail: async (
    companyId: number,
    orderId: number | string
  ) => {
    const { data } = await axiosClient.get<PathPickOrderDetailResponse>(
      url.getPathPickOrderDetail(companyId, orderId)
    );
    return data;
  },
};
